require('./brokerValuesView.scss');

const PropTypes = require('prop-types');

const React = require('react');
const { connect } = require('react-redux');

const BrokerValuesView = () => {

    return (
        <div className="broker-values-view">
            Broker Values view
        </div>
    );
};


BrokerValuesView.propTypes = {
    immGlobalPosition: PropTypes.object
};

module.exports.constructor = BrokerValuesView;
module.exports.BrokerValuesView = connect(
    state => ({
        brokerState: state.brokerState,
    }), {

    })(BrokerValuesView);
